<template>
    <div class="reg-temp-content-area main-content-height p-3">
        <div class="superadmin-dashboard-area edit-area">
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12">
                    <div class="card mb-4">
                        <div class="card-body">
                            <div class="registered-product-item w-half">
                                <router-link :to="{name: 'ResellerRegisteredProducts'}" class="mb-3 inline-block"
                                    ><i class="fas fa-long-arrow-alt-left"></i> Back</router-link
                                >
                                <h3 class="mb-4">Add product</h3>
                                <ul>
                                    <serial-and-model :data="form" />
                                    <li>
                                        <span class="semibold">Date purchased</span>
                                        <span>
                                            <vuejs-datepicker
                                                initial-view="year"
                                                maximum-view="year"
                                                v-model="form.date_of_purchase"
                                                :typeable="false"
                                                :full-month-name="true"
                                                :format="'yyyy-MM-dd'"
                                                class="input"
                                                id="purchased_date"
                                                placeholder="YYYY-MM-DD"
                                                :disabled-dates="purchaseDisabledDates"
                                            ></vuejs-datepicker>
                                        </span>
                                    </li>

                                    <li>
                                        <span class="semibold">Installation date</span>
                                        <span>
                                            <vuejs-datepicker
                                                initial-view="year"
                                                maximum-view="year"
                                                v-model="form.installation_date"
                                                :typeable="false"
                                                :full-month-name="true"
                                                :format="'yyyy-MM-dd'"
                                                class="input"
                                                id="install_date"
                                                placeholder="YYYY-MM-DD"
                                                :disabled-dates="installationDisabledDates"
                                            ></vuejs-datepicker>
                                        </span>
                                    </li>
                                    <li>
                                        <span class="semibold">Place of purchased</span>
                                        <span><input type="text" v-model="form.place_of_purchase" /></span>
                                    </li>

                                    <li class="border-b-1">
                                        <file-uploader label="Upload proof of purchase" id="proof_of_purchase" :form.sync="form" />
                                    </li>

                                    <li>
                                        <span class="semibold">Installation status</span>
                                        <span class="mt-1 coc-radio d-flex flex-column cursor-pointer">
                                            <label class="mr-2 font-normal" for="with_coc">
                                                <input
                                                    id="with_coc"
                                                    type="radio"
                                                    class="w-auto"
                                                    v-model="form.installation_compliance"
                                                    value="with_coc"
                                                />
                                                Installed with COC
                                            </label>
                                            <label class="mr-2 font-normal" for="without_coc">
                                                <input
                                                    id="without_coc"
                                                    type="radio"
                                                    class="w-auto"
                                                    v-model="form.installation_compliance"
                                                    value="without_coc"
                                                />
                                                Installed without a COC
                                            </label>
                                            <label class="mr-2 font-normal" for="no_coc">
                                                <input
                                                    id="no_coc"
                                                    type="radio"
                                                    class="w-auto"
                                                    v-model="form.installation_compliance"
                                                    value="no_coc"
                                                    name="installation_compliance"
                                                />
                                                No COC
                                            </label>
                                        </span>
                                    </li>
                                    <div v-show="form.installation_compliance == 'with_coc'">
                                        <li>
                                            <span class="semibold">COC number</span>
                                            <span> <input type="text" v-model="form.coc_number" /></span>
                                        </li>
                                        <li class="border-b-1">
                                            <file-uploader label="Upload coc certificate" id="coc_certificate" :form.sync="form" />
                                        </li>
                                    </div>

                                    <li>
                                        <span class="semibold">Depot</span>
                                        <small class="color-blue">Please select value from suggestion</small>
                                        <span>
                                            <vue-autosuggest
                                                :suggestions="purchasedFromSuggestions"
                                                :input-props="{
                                                    class: 'form-control',
                                                    id: 'autosuggest_purchasedfrom_input',
                                                    placeholder: 'Search Importer / Distributor'
                                                }"
                                                @input="onChangePurchasedFrom"
                                                @selected="selectPurchasedFromHandler"
                                                @click="onChangePurchasedFrom"
                                                :getSuggestionValue="purchasedFromSuggestionsValue"
                                            >
                                                <template slot-scope="{suggestion}">
                                                    <span class="my-suggestion-item">{{
                                                        suggestion.item.company ? suggestion.item.company : suggestion.item.email
                                                    }}</span>
                                                </template>
                                            </vue-autosuggest>
                                        </span>
                                    </li>

                                    <li>
                                        <span class="semibold">Customer</span>
                                        <small class="color-blue">Please select value from suggestion</small
                                        ><span>
                                            <vue-autosuggest
                                                :suggestions="soldToSuggestions"
                                                :input-props="{class: 'form-control', id: 'autosuggest_soldto_input', placeholder: 'Search Customer'}"
                                                @input="onChangeSoldTo"
                                                @selected="selectSoldToHandler"
                                                @click="onChangeSoldTo"
                                                :getSuggestionValue="soldToSuggestionsValue"
                                            >
                                                <template slot-scope="{suggestion}">
                                                    <span class="my-suggestion-item">{{
                                                        suggestion.item.fname ? suggestion.item.fname : suggestion.item.email
                                                    }}</span>
                                                </template>
                                            </vue-autosuggest>
                                        </span>
                                        <p class="mt-3">
                                            <em
                                                >Can't find ?
                                                <router-link :to="{name: 'ResellerCustomersAdd', query: {redirect: 'ResellerRegisteredProductAdd'}}"
                                                    >Add new customer</router-link
                                                ></em
                                            >
                                        </p>
                                    </li>
                                </ul>
                                <button class="btn btn-primary mt-3" @click.prevent="registerProduct()">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Env from '@/env';
import AuthApis from '@/controllers/AuthApis';
import Helpers from '@/helpers/index';
import {VueAutosuggest} from 'vue-autosuggest';
import moment from 'moment';

export default {
    components: {
        VueAutosuggest
    },
    name: 'customerRegProductAdd',
    data() {
        return {
            purchasedFromObj: {},
            purchasedFromSuggestions: [
                {
                    data: []
                }
            ],

            soldToObj: {},
            soldToSuggestions: [
                {
                    data: []
                }
            ],

            form: {
                hasOrderNumber: false,
                product_model: '',
                serial_number: '',
                sku_number: '',
                order_number: '',
                sku_with_serial_number: '',
                place_of_purchase: '',
                date_of_purchase: '',
                installation_date: '',
                installation_compliance: 'with_coc',
                coc_number: '',
                coc_certificate: {
                    url: '',
                    name: '',
                    type: '',
                    size: ''
                },
                invoice_number: '',
                purchased_from: '',
                sold_to: '',
                proof_of_purchase: {
                    incoming_url: '',
                    url: '',
                    name: '',
                    type: '',
                    size: ''
                }
            }
        };
    },

    watch: {
        'form.purchased_from_role'() {
            this.form.purchased_from = '';
        }

        // 'form.date_of_purchase': {
        //     handler(newVal) {
        //         if (this.form.installation_date && newVal && this.form.installation_date < newVal) {
        //             this.form.installation_date = null;
        //         } else if (this.form.installation_date && !newVal) {
        //             this.form.installation_date = null;
        //         }
        //     },
        //     deep: true
        // },
        // 'form.installation_date': {
        //     handler(newVal) {
        //         if (this.form.date_of_purchase && newVal && this.form.date_of_purchase > newVal) {
        //             this.form.date_of_purchase = null;
        //         } else if (this.form.date_of_purchase && !newVal) {
        //             this.form.date_of_purchase = null;
        //         }
        //     },
        //     deep: true
        // }
    },

    computed: {
        purchaseDisabledDates() {
            let disabled = {from: new Date()};
            if (this.form.installation_date) {
                const dayAfterInstall = new Date(this.form.installation_date);
                dayAfterInstall.setDate(dayAfterInstall.getDate());
                disabled.from = dayAfterInstall;
            }
            return disabled;
        },
        installationDisabledDates() {
            let disabled = {from: new Date()};

            if (this.form.date_of_purchase) {
                const dayBeforePurchase = new Date(this.form.date_of_purchase);
                dayBeforePurchase.setDate(dayBeforePurchase.getDate());
                disabled.to = dayBeforePurchase;
            }

            return disabled;
        }
    },

    methods: {
        /**
         * Fle handling
         */
        async fileChange(e) {
            let reader = new FileReader();
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                return;
            }
            // file type cehck
            if (this.$refs.coc_certificate.files[0].type != 'application/pdf') {
                document.getElementById('coc_certificate').value = '';
                this.$toasted.global.error({
                    message: 'Only pdf files are allowed.'
                });
                return;
            }

            // filesize prevent
            let limit5Mb = 5 * 1000000; // 5 MB limit
            if (this.$refs.coc_certificate.files[0].size > limit5Mb) {
                document.getElementById('coc_certificate').value = '';
                this.snackbar({
                    message: 'Sorry file cannot be more than 5MB.',
                    type: 'warning'
                });
                return;
            }

            this.form.coc_certificate = {
                url: URL.createObjectURL(files[0]),
                file: files[0],
                name: this.$refs.coc_certificate.files[0].name,
                type: this.$refs.coc_certificate.files[0].type,
                size: this.$refs.coc_certificate.files[0].size
            };
        },

        /**
         * Register product */

        async registerProduct() {
            const url = `${Env.baseUrl}/reseller/reg-product/create`;
            this.form.sku_with_serial_number = Helpers.getFullSerialNumber(this.form);
            this.form.installation_date = this.form.installation_date ? moment(this.form.installation_date).format('YYYY-MM-DD') : '';
            this.form.date_of_purchase = this.form.date_of_purchase ? moment(this.form.date_of_purchase).format('YYYY-MM-DD') : '';

            if (this.form.date_of_purchase && this.form.installation_date && this.form.installation_date < this.form.date_of_purchase) {
                return this.$toasted.global.error({
                    message: 'Installation date cannot be before date of purchase.'
                });
            }

            let formData = new FormData();
            for (let key in this.form) {
                if (key != 'coc_certificate') {
                    formData.append(key, this.form[key]);
                }
            }
            formData.append('coc_certificate', this.form.coc_certificate.file);
            this.spinner(true);
            AuthApis.postApi(url, formData)
                .then((res) => {
                    this.spinner(false);
                    this.$toasted.global.success({
                        message: 'Successfully added.'
                    });
                    this.$router.push({name: 'ResellerRegisteredProducts'});
                })
                .catch((err) => {
                    this.spinner(false);
                    this.$toasted.global.error({
                        message: err.response.data.errors[0]
                    });
                });
        },

        /**
         *
         * On change serach reftch suggest
         */
        onChangePurchasedFrom: _.debounce(function (company) {
            this.form.purchased_from = '';
            const url = `${Env.baseUrl}/reseller/seller/suggest`;
            AuthApis.postApi(url, {
                name: company
            })
                .then((res) => {
                    this.purchasedFromSuggestions[0].data = res.data.payload;
                })
                .catch((err) => {
                    console.log(err);
                });
        }, 800),

        /**
         *
         * On change serach reftch suggest
         */
        onChangeSoldTo: _.debounce(function (company) {
            this.form.sold_to = '';
            const url = `${Env.baseUrl}/reseller/customers/suggest`;
            AuthApis.postApi(url, {
                name: company
            })
                .then((res) => {
                    this.soldToSuggestions[0].data = res.data.payload;
                })
                .catch((err) => {
                    console.log(err);
                });
        }, 800),

        /**
         * On click handle seller
         */
        selectPurchasedFromHandler(obj) {
            this.purchasedFromObj = obj.item;
            this.form.purchased_from = obj.item.id;
        },

        selectSoldToHandler(obj) {
            this.soldToObj = obj.item;
            this.form.sold_to = obj.item.id;
        },

        purchasedFromSuggestionsValue(obj) {
            return obj.item.company ? obj.item.company : obj.item.email;
        },
        soldToSuggestionsValue(obj) {
            //sold to is customer so always f name
            return obj.item.fname ? obj.item.fname : obj.item.email;
        }
    }
};
</script>
